import { useAuth } from "@/context/AuthContext";

// Detects whether the app is running inside an Android Trusted Web Activity (TWA)
// or installed PWA, where Google Play Billing policy forbids showing web checkout.
export function isAndroidApp() {
  if (typeof window === "undefined") return false;
  // Manual test override
  if (window.__TWA_TEST__) return true;
  // TWA sets the referrer to the wrapping Android app
  try {
    if (document.referrer && document.referrer.startsWith("android-app://")) return true;
  } catch (_) {}
  // Installed PWA on Android (standalone display mode + Android UA)
  try {
    const standalone = window.matchMedia && window.matchMedia("(display-mode: standalone)").matches;
    const isAndroid = /Android/i.test(navigator.userAgent || "");
    if (standalone && isAndroid) return true;
  } catch (_) {}
  return false;
}

// Gate for any digital-goods (subscriptions, premium, credits) UI.
// Admins are exempt so they can preview/check pricing even inside the app.
export function useBillingGate() {
  const { user } = useAuth();
  const isApp = isAndroidApp();
  const gated = isApp && user?.role !== "admin";
  return { isApp, gated };
}
